import { render, staticRenderFns } from "./ElibroModule.vue?vue&type=template&id=2792d392&scoped=true"
import script from "./ElibroModule.vue?vue&type=script&lang=js"
export * from "./ElibroModule.vue?vue&type=script&lang=js"
import style0 from "./ElibroModule.vue?vue&type=style&index=0&id=2792d392&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2792d392",
  null
  
)

export default component.exports